import { useState, useMemo } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Box
} from "@mui/material";
import { useAsset } from "../../context/AssetContext";

const AssetIdEditModal: React.FC = () => {
  const {asset, user, isEditAssetIdModalOpen, closeEditAssetIdModal} = useAsset();
  if (!asset) return null;

  const oldAssetId = asset.assetIdentifier || asset.assetId.split("-")[0]
  const [newAssetId, setNewAssetId] = useState(oldAssetId);
  const [reason, setReason] = useState("");

  const isSubmitDisabled = useMemo(() => {
    return newAssetId.trim() === oldAssetId.trim() || !reason.trim();
  }, [newAssetId, reason, asset.assetId]);

  const handleSubmit = async () => {
    if (isSubmitDisabled) {
      return;
    }

    try {
      const payload = {
        pk: asset.pk,
        oldAssetId: oldAssetId.trim(),
        newAssetId: newAssetId.trim(),
        user,
        reason: reason.trim(),
        updateTime: new Date().toISOString()
      };

      // TODO: Replace with actual API call
      console.log("Submitting:", payload);

      closeEditAssetIdModal();
    } catch (error) {
      console.error("Error updating asset ID:", error);
    }
  };

  const handleAssetIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewAssetId(e.target.value.toUpperCase());
  };

  return (
    <Dialog open={isEditAssetIdModalOpen} onClose={closeEditAssetIdModal} fullWidth maxWidth="sm">
      <DialogTitle>Edit Asset ID</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 1 }}>
          <Typography variant="body2" color="textSecondary">
            Current Asset ID: {oldAssetId}
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            label="New Asset ID"
            type="text"
            fullWidth
            value={newAssetId}
            onChange={handleAssetIdChange}
            inputProps={{
              style: { textTransform: "uppercase" }
            }}
          />
          <TextField
            margin="dense"
            label="Reason for change"
            type="text"
            fullWidth
            multiline
            rows={4}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            required
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeEditAssetIdModal}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" disabled={isSubmitDisabled}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssetIdEditModal;